export const toSentence = (items: string[], word = "and"): string => {
  return new Intl.ListFormat("en", {
    style: "long",
    type: word === "and" ? "conjunction" : "disjunction",
  }).format(items);
};
